import * as signalR from "@microsoft/signalr";

class SignalRConnection {
    constructor() {
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl("/hub")
            .configureLogging(signalR.LogLevel.Information)
            .build();
        this.delay = 2000;
        this.connection.onclose(() => this.startConnection());
    }

    startConnection() {
        this.connection.start().catch(err => {
            console.error(`Reconnect error: ${err.toString()}`);

            if (this.delay < 16000) {
                this.delay *= 2;
            }

            setTimeout(() => this.startConnection(), this.delay);
        });
    }
}

export default new SignalRConnection();
